// Fires a custom event through Umami. window.umami is defined by the Umami
// tracker script (mounted in src/routes/__root.tsx) once it has loaded. Umami
// event data accepts strings and numbers; we coerce every value to a string and
// drop null/undefined, keeping the previous snake_case prop contract intact.
export function track(event: string, params: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined') return
  const data: Record<string, string> = {}
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) data[key] = String(value)
  }
  window.umami?.track(event, data)
}

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, string>) => void
    }
    // Dev/e2e buffer: the Umami stub (e2e/umami-stub.ts) records each would-be
    // send here. A pageview has no `name`; a custom event carries name + data.
    __umamiEvents?: Array<{ name?: string; data?: Record<string, unknown> }>
  }
}
